(function () {
  'use strict';

  if (window.__hvAddonGuard) return;

  /* Variants that are bundle-add-on pricing only (gummies $20).
     Items carrying the `_Bundle Add-on` line property (extra gel jars) count too. */
  var ADDON_VARIANTS = {
    45145079316675: true,
    45192050376899: true
  };
  var BUNDLE_URL = '/pages/mix-match-bundle';
  var CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]',
    '.shopify-payment-button',
    'shopify-accelerated-checkout-cart'
  ].join(',');

  var addonOnly = false;
  var addonItems = [];
  var cartReady = false;
  var cartRequest = null;
  var banner = null;

  function isAddonItem(item) {
    if (ADDON_VARIANTS[Number(item && (item.variant_id || item.id))]) return true;
    var props = item && item.properties;
    return !!(props && String(props['_Bundle Add-on']).trim() === 'true');
  }

  function applyCart(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    addonItems = items.filter(isAddonItem);
    var regular = items.length - addonItems.length;
    addonOnly = addonItems.length > 0 && regular === 0;
    cartReady = true;
    setCheckoutDisabled(addonOnly);
    if (addonOnly) showBanner();
    else if (banner) banner.hidden = true;
    return addonOnly;
  }

  function refreshCart(force) {
    if (cartRequest && !force) return cartRequest;
    cartRequest = fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to inspect cart');
      return response.json();
    }).then(applyCart).catch(function () {
      cartReady = false;
      return addonOnly;
    }).finally(function () {
      cartRequest = null;
    });
    return cartRequest;
  }

  function ensureBanner() {
    if (banner && banner.isConnected) return banner;
    banner = document.createElement('div');
    banner.id = 'hv-addon-guard';
    banner.setAttribute('role', 'alert');
    banner.setAttribute('aria-live', 'assertive');
    banner.innerHTML = [
      '<div class="hv-ag-card">',
      '<button type="button" class="hv-ag-close" aria-label="Close">&times;</button>',
      '<strong>That price is a bundle add-on</strong>',
      '<p>The $20 add-on price only applies alongside a bundle. Pick a bundle to keep the discount, or remove the add-on to continue.</p>',
      '<button type="button" class="hv-ag-shop">Choose a bundle</button>',
      '<button type="button" class="hv-ag-remove">Remove add-on</button>',
      '<p class="hv-ag-error" hidden></p>',
      '</div>'
    ].join('');
    var style = document.createElement('style');
    style.id = 'hv-addon-guard-styles';
    style.textContent = [
      '#hv-addon-guard{position:fixed;z-index:2147483000;inset:auto 16px 18px 16px;display:flex;justify-content:center;font-family:inherit}',
      '#hv-addon-guard[hidden]{display:none}',
      '.hv-ag-card{position:relative;width:min(100%,520px);padding:20px 52px 20px 20px;border:2px solid #b42318;border-radius:14px;background:#fff7f5;color:#32100d;box-shadow:0 12px 40px rgba(50,16,13,.22)}',
      '.hv-ag-card strong{display:block;font-size:18px;line-height:1.25}',
      '.hv-ag-card p{margin:7px 0 14px;font-size:14px;line-height:1.45}',
      '.hv-ag-shop{min-height:44px;padding:10px 18px;border:0;border-radius:999px;background:#173f35;color:#fff;font:inherit;font-weight:700;cursor:pointer;margin-right:8px}',
      '.hv-ag-remove{min-height:44px;padding:10px 18px;border:1px solid #173f35;border-radius:999px;background:transparent;color:#173f35;font:inherit;font-weight:700;cursor:pointer}',
      '.hv-ag-remove[disabled],.hv-ag-shop[disabled]{opacity:.65;cursor:wait}',
      '.hv-ag-close{position:absolute;right:14px;top:10px;border:0;background:transparent;color:#32100d;font-size:28px;line-height:1;cursor:pointer}',
      '.hv-ag-error{color:#b42318;font-weight:700}',
      '[data-hv-addon-guard-disabled="true"]{opacity:.48!important;cursor:not-allowed!important}',
      'shopify-accelerated-checkout-cart[data-hv-addon-guard-disabled="true"],.shopify-payment-button[data-hv-addon-guard-disabled="true"]{display:none!important}',
      '@media(min-width:700px){#hv-addon-guard{inset:auto 24px 24px auto}.hv-ag-card{width:440px}}'
    ].join('');
    document.head.appendChild(style);
    document.body.appendChild(banner);

    banner.querySelector('.hv-ag-close').addEventListener('click', function () {
      banner.hidden = true;
    });
    banner.querySelector('.hv-ag-shop').addEventListener('click', function () {
      window.location.assign(BUNDLE_URL);
    });
    banner.querySelector('.hv-ag-remove').addEventListener('click', removeAddons);
    return banner;
  }

  function showBanner() {
    var element = ensureBanner();
    element.hidden = false;
    element.querySelector('.hv-ag-error').hidden = true;
  }

  function setCheckoutDisabled(disabled) {
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (control) {
      if (disabled) {
        control.setAttribute('data-hv-addon-guard-disabled', 'true');
        control.setAttribute('aria-disabled', 'true');
        if ('disabled' in control) control.disabled = true;
      } else if (control.getAttribute('data-hv-addon-guard-disabled') === 'true') {
        control.removeAttribute('data-hv-addon-guard-disabled');
        control.removeAttribute('aria-disabled');
        if ('disabled' in control) control.disabled = false;
      }
    });
  }

  function removeAddons() {
    if (!addonItems.length) return;
    var element = ensureBanner();
    var button = element.querySelector('.hv-ag-remove');
    var error = element.querySelector('.hv-ag-error');
    var updates = {};
    addonItems.forEach(function (item) {
      updates[item.key] = 0;
    });
    button.disabled = true;
    button.textContent = 'Removing...';
    error.hidden = true;
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to update cart');
      window.location.reload();
    }).catch(function () {
      button.disabled = false;
      button.textContent = 'Try again';
      error.textContent = 'We could not update your cart. Please refresh and try again.';
      error.hidden = false;
    });
  }

  function blockCheckout(event) {
    if (!addonOnly) return false;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    showBanner();
    refreshCart(true).then(function (bad) {
      if (bad) showBanner();
    });
    return true;
  }

  document.addEventListener('click', function (event) {
    var control = event.target && event.target.closest ? event.target.closest(CHECKOUT_SELECTOR) : null;
    if (!control) return;
    blockCheckout(event);
  }, true);

  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    var checkoutIntent = submitter && submitter.matches && submitter.matches('[name="checkout"]');
    if (!checkoutIntent && event.target && event.target.action) {
      checkoutIntent = /\/checkout(?:[/?#]|$)/.test(event.target.action);
    }
    if (!checkoutIntent) return;
    blockCheckout(event);
  }, true);

  ['variant:add', 'cart:refresh', 'cart:change', 'cart:drawer:change'].forEach(function (name) {
    document.addEventListener(name, function () { refreshCart(true); });
  });

  var observer = new MutationObserver(function () {
    if (cartReady) setCheckoutDisabled(addonOnly);
  });

  function init() {
    observer.observe(document.documentElement, { childList: true, subtree: true });
    refreshCart(true);
  }

  window.__hvAddonGuard = {
    isAddonItem: isAddonItem,
    refresh: refreshCart
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
